import { Injectable } from '@angular/core';
import { CalendarEvent } from 'angular-calendar';
import { Observable } from 'rxjs';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';
import { Availability } from 'src/app/shared/models/services-aide-emploi/availability';

@Injectable({
	providedIn: 'root'
})
export class AvailabilityService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 * Récupère la liste des disponibilités
	 * @returns
	 */
	getAllAvailability(
		year: number,
		weekNumber: number
	): Observable<CalendarEvent[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.availabilityUrl}/${year}/${weekNumber}`,
			'getAllAvailability'
		);
	}

	/**
	 * Récupère la liste des disponibilités
	 * @returns
	 */
	getPrescriptionAvailability(
		year: number,
		weekNumber: number
	): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.availabilityUrl}/${year}/${weekNumber}/prescription`,
			'getPrescriptionAvailability'
		);
	}

	getAllAvailabilitiesByEmployeeId(
		employeeId: number
	): Observable<Availability[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.availabilityUrl}/employee/${employeeId}`,
			'getAllAvailabilitiesByEmployeeId'
		);
	}

	postAvailability(availability: Availability): Observable<Availability> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.availabilityUrl}/employee`,
			'getAllAvailabilitiesByEmployeeId',
			availability
		);
	}

	deleteAvailability(availabilityId: string): Observable<Availability> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.availabilityUrl}/${availabilityId}`,
			'deleteAvailability'
		);
	}
}
